import React from 'react';
import { Grid, Header, Icon, Segment } from 'semantic-ui-react';
import axios from 'axios';
// import { fadeIn, zoomIn } from 'react-animations';
// import { keyframes } from 'styled-components';
// import styled from 'styled-components';
import StudentUpcomingExams from '../StudentCoursesOverview/StudentUpcomingExams';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class DefaultHomePage extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div >
                <Header as="h1"><FormattedMessage id="sidebar.home" /></Header>
                <Grid centered stackable>

                    <Grid.Row>
                        <Grid.Column width={16} stretched >
                            <Segment.Group raised>
                                <Segment>
                                    <Icon name="university" />Dobrodošli na <strong><i>eUNSA </i></strong>sistem.
                                </Segment>
                                <Segment style={{ textAlign: 'justify', textJustify: 'interWord', padding: '20px' }}>
                                    Jedinstveni informacioni sistem Univerziteta u Sarajevu <strong><i>eUNSA </i></strong> podrazumijeva zajednički integrisani resurs podataka koji se organizira na najefektivniji i najefikasniji način u skladu sa osnovama softverskog inžinjeringa, a u svrhu uspješnog izvršavanja zadataka nadležnih obrazovnih vlasti, kao i nadležnih tijela Univerziteta u okviru utvrđenih nadležnosti. Uz pomoć <strong><i>eUNSA </i></strong> sistema vodi se evidencija podataka o studentima, zaposlenicima i angažovanim licima, nastavnom procesu i naučnoistraživačkom radu i imovini, te prostornim i materijalno-tehničkim kapacitetima Univerziteta u Sarajevu.
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Home/DefaultHomePage.js